<template>
    <div>
        <div id="topPanel">
            <div id="topHeadLogo">
                <div class="float-left">
                    <a target="_blank" href="http://www.standardmediaindex.com/">
                        <img class="sprite-smi-logo"
                            style="background-color:transparent"
                            v-bind:src="SMI_logo" alt="SMI" />
                    </a>
                </div>
                <div class="float-right" style="font-size: 15px;">
                    <div v-if="!needToLogin">
                        <p>Welcome <b>{{userName}}</b> | <a v-on:click="logout">Logout</a> <br /></p>
                    </div>
                    <div v-if="needToLogin">
                        <a v-on:click="showLogin">Login</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from '../services/axiosClient'
import * as config from '../services/config'
export default {
    props: [
        'needToLogin', 'userName'
    ],
    data() {
        return {
            SMI_logo: config.rootURL + '/Content/images/SMI_logo_White.png',
            showLoadingToLoadingProp: true
        }
    },

     async created(){
            var self = this;
            var logoPromise = await axios.get('/api/Hubs/SMILogo');
            var logo = logoPromise.data;
            self.SMI_logo = config.rootURL  + '/content/images/' + logo;
        },

    methods: {

        handleShowLoading: function(payload) {
            this.showLoadingToLoadingProp = payload;
        },
        showLogin: function() {
            this.needToLogin = true;
        },
        async logout() {
            this.$emit('logoutclick', true);
            var url = '/api/Auth/Logout';
            try{
                var logoutPromise = await axios.get(url);
                location.reload();
            }catch(err){
                console.log('err',err);
            }
        }
    },
    watch: {
        showLoadingToLoadingProp: function(newValue) {
            this.$emit('showLoading', newValue);
        }
    }
}

</script>